import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../../lib/api";

const Ctx = createContext({ phone: "", host_name: "", host_address: "", mediator: "", email: "habitalys@atomicmail.io" });

export const SiteConfigProvider = ({ children }) => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    api.get("/config").then((r) => setCfg(r.data)).catch(() => setCfg(null));
  }, []);
  return <Ctx.Provider value={cfg || { phone: "", host_name: "", host_address: "", mediator: "", email: "habitalys@atomicmail.io" }}>{children}</Ctx.Provider>;
};

export const useSiteConfig = () => useContext(Ctx);
